// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import animated from 'animate.css'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import VueScrollTo from 'vue-scrollto'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import MetaInfo from 'vue-meta-info'
import {getCookie,addCookie,delCookie} from "./api/cookie";

Vue.config.productionTip = false
Vue.use(animated)
Vue.use(iView)
Vue.use(VueScrollTo)
Vue.use(GeminiScrollbar)
Vue.use(MetaInfo)
Vue.use({getCookie,addCookie,delCookie})

// 注册一个全局自定义指令 `v-focus`
Vue.directive('focus', {
  focus: {
    inserted: function (el, {value}) {
      if (value) {
        el.focus();
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js